// extracted by mini-css-extract-plugin
module.exports = {"departments":"pe","departmentHeading":"qe","departmentSection":"re","departmentName":"se","departmentLink":"te","expandIcon":"ue"};